import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EditTicketComponent from "../../../components/Customer/tickets/EditTicketComponent";

const DetailTicketPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate('/ho-tro/danh-sach-ho-tro.html');
    }

    return <EditTicketComponent ticketId={ params.ticketId } shouldRedirect={ () => redirectBack() } />;

}

export default DetailTicketPage;